/* eslint-disable react/no-array-index-key */
import { useState, Fragment } from "react";
import { Link as RouterLink } from "@tanstack/react-router";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Drawer,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import SearchIcon from "../../../icons/Search";
import XIcon from "../../../icons/X";
import Scrollbar from "../../general/Scrollbar";
import wait from "../../../helpers/wait";

// Mock data

const results = [
  {
    description:
      "Algolia broadly consists of two parts: search implementation and search analytics. We provide tools that make it easy for your developers...",
    title: "What does Algolia do?",
  },
  {
    description:
      "To be clear, search doesn’t know the direction that your business should take. However, it can help you gather information on what your customers want...",
    title: "Search as a feedback loop",
  },
  {
    description:
      "Algolia provides your users with a fast and rich search experience. Your Algolia search interface can contain a search bar, filters, infinite scrolling...",
    title: "What can Algolia do for my users?",
  },
];

const ContentSearch = () => {

  // Hooks
  
  const [value, setValue] = useState("");
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);

  // Handle Search Pop-over

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Handle Search

  const search = async () => {
    setShowResults(false);
    setIsLoading(true);
    // Do search here
    await wait(1500);
    setIsLoading(false);
    setShowResults(true);
  };

  const handleClick = () => {
    search();
  };

  const handleKeyUp = (event) => {
    if (event.code === "ENTER") {
      search();
    }
  };

  // Rendering

  return (
    <Fragment>
      <Tooltip title="Search">
        <IconButton color="inherit" onClick={handleOpen}>
          <SearchIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Drawer
        anchor="top"
        ModalProps={{ BackdropProps: { invisible: true } }}
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: "100%" },
        }}
        variant="temporary"
      >
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <IconButton onClick={handleClose}>
              <XIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ p: 3 }}>
          <Container>
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
              }}
            >
              <TextField
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
                onChange={(event) => setValue(event.target.value)}
                onKeyUp={handleKeyUp}
                placeholder="Search..."
                value={value}
              />
              <Button
                color="primary"
                onClick={handleClick}
                size="large"
                sx={{ ml: 2 }}
                variant="contained"
              >
                Search
              </Button>
            </Box>
            <Box sx={{ mt: 3 }}>
              <Scrollbar options={{ suppressScrollX: true }}>
                {isLoading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <Fragment>
                    {showResults && (
                      <Fragment>
                        {results.map((result, i) => (
                          <Box key={i} sx={{ mb: 2 }}>
                            <Link
                              color="textPrimary"
                              component={RouterLink}
                              to="/"
                              variant="h5"
                            >
                              {result.title}
                            </Link>
                            <Typography color="textPrimary" variant="body2">
                              {result.description}
                            </Typography>
                          </Box>
                        ))}
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </Scrollbar>
            </Box>
          </Container>
        </Box>
      </Drawer>
    </Fragment>
  );
};

export default ContentSearch;
